jQuery( '.staggered-section .staggered-slider' ).slick( {
    dots: false,
    infinite: false,
    speed: 300,
    cssEase: "ease",
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
} );